(function ($) {
  'use strict';

  $(document).ready(init);

  function init() {
    var $quicklinks = $('.block-quicklinks');
    var $visualBlocks = $('.paragraph-visual-with-blocks__visual-blocks');

    if ($quicklinks.length && $visualBlocks.length) {
      $quicklinks.insertBefore($visualBlocks[0]);
    }
  }

})(jQuery);
